/*
 * Public API Surface of ionic-navigationbar-color
 */

export * from './lib/ionic-navigationbar-color.component';
